import { GetterTree } from "vuex";
import { RootState } from "@/store/interfaces/root";
import { UserState, UserGetters } from "@/store/interfaces/user";
import { GetterTypes } from "./getter-types";

export const getters: GetterTree<UserState, RootState> & UserGetters = {
  /**
    Get user status from User module state
    @param state - User module state
    @returns - {
      status: boolean,
      didInvalidate: boolean,
      receivedAt: number,
      connectionError: boolean,
      user: object
    }
  */
  [GetterTypes.GET_USER_STATUS](state) {
    return state.user;
  },

  /**
    Get user passwordReset status from User module state
    @param state - User module state
    @returns - {
      status: boolean,
      didInvalidate: boolean,
      receivedAt: number,
      connectionError: boolean
    }
  */
  [GetterTypes.GET_REQUEST_PASSWORD_RESET_STATUS](state) {
    return state.passwordReset;
  },

  /**
    Get register validation status from User module state
    @param state - User module state
    @returns - {
      status: boolean,
      didInvalidate: boolean,
      receivedAt: number,
      connectionError: boolean,
      response: object
    }
  */
  [GetterTypes.GET_REGISTER_VALIDATION_STATUS](state) {
    return state.registerValidation;
  },

  /**
    Get register status from User module state
    @param state - User module state
    @returns - {
      status: boolean;
      didInvalidate: boolean;
      receivedAt: number;
      flowState: string;
      email: string;
      error: boolean;
    }
  */
  [GetterTypes.GET_REGISTER_STATUS](state) {
    return state.register;
  }
};
